let _auth: AuthHub;
let _notifiche: NotificheHub;
let _utilityHub: UtilityHub;

$(document).ready(function () {
    _auth = $.connection.authHub;
    _notifiche = $.connection.notificheHub;
    _utilityHub = $.connection.utilityHub;

});

interface SignalR {
    authHub: AuthHub;
    utilityHub: UtilityHub;
}

interface UtilityHub {
    server: UtilityHubServer;
    client: UtilityHubClient;
}

interface UtilityHubServer {
}

interface UtilityHubClient {
    pulisciSessione: () => void;
}

interface AuthHub {
    server: AuthHubServer;
    client: AuthHubClient;
}

interface AuthHubServer {
    login(): JQueryPromise<string>;
}

interface AuthHubClient {
    init: () => void;
}
